import React, { Component } from 'react';
import {Modal, Button, Grid, Row, Label, Col } from 'react-bootstrap';
import $ from 'jquery';
import ReactTelInput from 'react-telephone-input';
import './request-sample.css';

class RequestSample extends Component {
    constructor(props,context) {
        super(props, context);

        this.state = {
            data: this.props.data,
            lgShow: false
        };
        console.log("#33333",this.state)
        this.isBusinessEmail = this.isBusinessEmail.bind(this);
        this.isValidPhone = this.isValidPhone.bind(this);
    }
    render() {
        let lgClose = () => this.setState({ lgShow: false });
        let img_url = 'https://mordorintelligence.com:81';
        return (
            <Modal
                {...this.props}
                bsSize="large"
                aria-labelledby="contained-modal-title-lg"
                id="myModal"
            >

                <Modal.Body >


                    <div class="form-container">
                        <span class="custom-close-button" onClick={this.props.onHide}></span>
                        <h3 class="text-center main-heading">PLEASE FILL THE DETAILS TO CONTINUE</h3>
                        <form action="">

                            <div class="primary-form">
                                <div class="form-input flex">
                                    <label for="vsitor-name">Name</label>
                                    <div class="input-group flex">
                                        <input type="text" id="name1" placeholder="First Name" class="input" required />
                                            <input type="text" id="name2" placeholder="Last Name" class="input" required />
                                    </div>
                                </div>
                                <div class="form-input flex">
                                    <label for="vsitor-email">Business Email</label>
                                    <input type="email" id="email12" placeholder="name@company.com" onBlur={(e) => this.isBusinessEmail(e)} required />
                                        <div className="input-error-message"></div>
                                </div>
                                <div class="form-input flex">
                                    <label for="visitor-phone">Phone</label>
                                    <ReactTelInput
                                        defaultCountry="us"
                                        flagsImagePath='/img/flags.png'
                                        onBlur={(e) => this.isValidPhone(e)}
                                    />
                                </div>
                                <div class="form-input flex">
                                    <label for="vsitor-designation">Designation</label>
                                    <select id="designation" required>
                                        <option value="" selected disabled hidden>Select</option>
                                        <option value="Researcher">Researcher</option>
                                        <option value="VP">VP</option>
                                        <option value="CEO">CEO</option>
                                        <option value="Analyst">Analyst</option>
                                        <option value="Sales_Manager">Sales Manager</option>
                                        <option value="IT_professional">IT professional</option>
                                        <option value="Business_Head">Business Head</option>
                                        <option value="Student">Student</option>
                                        <option value="Consultant">Consultant</option>
                                        <option value="Managing_Director">Managing Director</option>
                                        <option value="Coordinator">Coordinator</option>
                                        <option value="Others">Others</option>
                                    </select>
                                </div>
                                <p>* All your information will be kept confidential</p>
                            </div>
                            <div class="secondary-inputs">


                                <div class="qstn01_data" >
                                    <h5> <i class="back-btn fa fa-chevron-circle-left " aria-hidden="true"></i> I would like to discuss further steps via:</h5>

                                    <input type="hidden" name="q6" id="q6" value="I would like to discuss further steps via" />


                                    <div class="radio-buttons flex">
                                        <div class="radio-button">
                                            <input type="radio" id="radio01" value="Email" class="followup_qustn_radio" name="radio" value="Email" />
                                            <label for="radio01"><span></span>Email</label>
                                        </div>

                                        <div class="radio-button">
                                            <input type="radio" id="radio02" class="followup_qustn_radio" name="radio" value="Phone"/>
                                            <label for="radio02"><span></span>Phone</label>
                                        </div>

                                        <div class="radio-button">
                                            <input type="radio" id="radio03" class="followup_qustn_radio" name="radio" value="Skype / Hangouts" />
                                            <label for="radio03"><span></span>Skype / Hangouts</label>
                                        </div>
                                        <textarea class="form-control textArea-style" rows="5" id="specifics_for_analyst"  placeholder="Anything specific you would like to discuss with our analyst?"></textarea>

                                    </div>

                                </div>


                                <div class="qstn2_data" >
                                    <input type="hidden" name="qnumber" value="q6" id="qnumber" />
                                    <h5> I want to:</h5>
                                    <input type="hidden" name="q2" id="q2" value="I want to" />
                                    <span class="checkbox-inline">
                                                        <input type="checkbox" id="checkbox1" name="checkboxar[]" value="Talk to Analyst" />&nbsp;&nbsp;&nbsp;&nbsp;Talk to Analyst
                                                </span>
                                    <span class="checkbox-inline">
                                                        <input type="checkbox" id="checkbox2" name="checkboxar[]" value="Buy the report" />&nbsp;&nbsp;&nbsp;&nbsp;Buy the report
                                                </span>
                                    <span class="checkbox-inline">
                                                        <input type="checkbox" id="checkbox3" name="checkboxar[]" value="Just browse" />&nbsp;&nbsp;&nbsp;&nbsp;Just browse
                                                </span>
                                </div>


                                <div class="qstn3_data">
                                    <h5>
                                        <i class="back-btn fa fa-chevron-circle-left " aria-hidden="true"></i> I need the complete report in:</h5>
                                    <input type="hidden" name="q3" id="q3" value="I need the complete report in" />



                                    <div class="radio-buttons flex">
                                        <div class="radio-button">
                                            <input type="radio" id="radio1" class="followup_qustn_radio" name="radioboxar" value="Less than 48 hours" />
                                            <label for="radio1"><span></span>Less than 48 hours</label>
                                        </div>

                                        <div class="radio-button">
                                            <input type="radio" id="radio2" class="followup_qustn_radio" name="radioboxar" value="A week" />
                                            <label for="radio2"><span></span>A week</label>
                                        </div>

                                        <div class="radio-button">
                                            <input type="radio" id="radio3" class="followup_qustn_radio" name="radioboxar" value="A month" />
                                            <label for="radio3"><span></span>A month</label>
                                        </div>
                                        <div class="radio-button">
                                            <input type="radio" id="radio4" class="followup_qustn_radio" name="radioboxar" value="Future Requirement" />
                                            <label for="radio4"><span></span>Future Requirement</label>
                                        </div>

                                    </div>
                                </div>


                                <div class="qstn4_data">
                                    <h5>  I want to know: </h5>
                                    <input type="hidden" name="q4" id="q4" value="I want to know" />
                                    <span class="checkbox-inline">
                                              <input type="checkbox" id="checkbox1" name="checkboxar[]" value="More about the market" />&nbsp;&nbsp;&nbsp;&nbsp;More about the market
                                            </span> <span class="checkbox-inline" >
                                              <input type="checkbox" id="checkbox2" name="checkboxar[]" value="Your Data Sources &amp; Engineering" />&nbsp;&nbsp;&nbsp;&nbsp;Your Data Sources &amp; Engineering
                                            </span> <span class="checkbox-inline" >
                                              <input type="checkbox" id="checkbox3" name="checkboxar[]" value="Customer Benefits You Offer" />&nbsp;&nbsp;&nbsp;&nbsp;Customer Benefits You Offer
                                            </span>
                                </div>


                                <div class="qstn5_data" >
                                    <h5 > I am looking for:</h5>
                                    <input type="hidden" name="q5" id="q5" value="I am looking for" />
                                    <span class="radio-inline" >
                                          <input type="radio" id="radio1" name="radioboxar" value="Customised report" />&nbsp;&nbsp;&nbsp;&nbsp;Customised report
                                        </span> <span class="radio-inline" >
                                          <input type="radio" id="radio2" name="radioboxar" value="Off-the-shelf report" />&nbsp;&nbsp;&nbsp;&nbsp;Off-the-shelf report
                                        </span> <span class="radio-inline" >
                                          <input type="radio" id="radio3" name="radioboxar" value="Free sample" />&nbsp;&nbsp;&nbsp;&nbsp;Free sample
                                        </span>

                                    <div class="radio-buttons flex">
                                        <div class="radio-button">
                                            <input type="radio" id="radio1" class="followup_qustn_radio" name="radioboxar" value="Customised report" />
                                            <label for="radio1"><span></span>Customised report</label>
                                        </div>

                                        <div class="radio-button">
                                            <input type="radio" id="radio2" class="followup_qustn_radio" name="radioboxar" value="Off-the-shelf report" />
                                            <label for="radio2"><span></span>Off-the-shelf report</label>
                                        </div>

                                        <div class="radio-button">
                                            <input type="radio" id="radio3" class="followup_qustn_radio" name="radioboxar" value="Free sample" />
                                            <label for="radio3"><span></span>Free sample</label>
                                        </div>


                                    </div>
                                </div>


                                <div class="qstn6_data">
                                    <h5>I would like to:</h5>
                                    <input type="hidden" name="q6" id="q6" value="I would like to discuss further steps via" />


                                    <div class="radio-buttons flex">
                                        <div class="radio-button">
                                            <input type="radio" id="radio011" class="followup_qustn_radio" value="Procure the full report" name="radioboxar" />
                                            <label for="radio011"><span></span>Procure the full report</label>
                                        </div>

                                        <div class="radio-button">
                                            <input type="radio" id="radio021" class="followup_qustn_radio" value="Customize the report" name="radioboxar" />
                                            <label for="radio021"><span></span>Customize the report</label>
                                        </div>

                                        <div class="radio-button">
                                            <input type="radio" id="radio031" class="followup_qustn_radio" value="Speak with the analyst" name="radioboxar" />
                                            <label for="radio031"><span></span>Speak with the analyst</label>
                                        </div>
                                        <div class="radio-button">
                                            <input type="radio" id="radio041" class="followup_qustn_radio" value="Get an overview of the market" name="radioboxar" />
                                            <label for="radio041"><span></span>Get an overview of the market</label>
                                        </div>

                                    </div>
                                </div>


                                <div class="qstn7_data">
                                    <h5 class="iamusing" > I am using the sample document to: </h5>
                                    <input type="hidden" name="q7" id="q7" value="I am using the sample document to" />
                                    <span class="checkbox-inline" >
                                              <input type="checkbox" id="checkbox1" name="checkboxar[]" value="Evaluate available options" />&nbsp;&nbsp;&nbsp;&nbsp;Evaluate available options
                                            </span> <span class="checkbox-inline" >
                                              <input type="checkbox" id="checkbox2" name="checkboxar[]" value="Ratify my purchase decision" />&nbsp;&nbsp;&nbsp;&nbsp;Ratify my purchase decision
                                            </span> <span class="checkbox-inline" >
                                              <input type="checkbox" id="checkbox3" name="checkboxar[]" value="Better understand the market" />&nbsp;&nbsp;&nbsp;&nbsp;Better understand the market
                                            </span>
                                </div>
                                <div class="qstn8_data">
                                    <h5 class="iamusing" >
                                        <i class="back-btn fa fa-chevron-circle-left " aria-hidden="true"></i> What would you like to add to the report?</h5>
                                    <small >All full report purchase come with up to 10% free additional customization.</small>
                                    <input type="hidden" name="q8" id="q8" value="I have custom requirements" />
                                    <textarea class="form-control textArea-style" rows="5" id="custom_requirements"></textarea>
                                </div>


                            </div>
                            <div class="btn-submit text-center">
                                <button type="button" id="new_button1">SUBMIT</button>
                            </div>
                        </form>
                    </div>


                </Modal.Body>
                {/*<Modal.Footer>*/}
                    {/*<Button onClick={this.props.onHide}>Close</Button>*/}
                    {/*<input type="button" id="new_button1" className="btn btn-success"  value="SUBMIT" />*/}

                {/*</Modal.Footer>*/}
            </Modal>

        );
    }

    isBusinessEmail(e) {
        console.log(e.target.value);
        var email = e.target.value;
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        console.log(re.test(email));
        var isValidEmail = re.test(email);

        if(isValidEmail) {
            if( email.split("@")[1].split(".")[0] === "gmail" || email.split("@")[1].split(".")[0] === "yahoo" ||
                email.split("@")[1].split(".")[1] === "edu"   || email.split("@")[1].split(".")[1] === "student" ||
                email.split("@")[1] === "163.com" || email.split("@")[1].split(".")[0] === "naver"){
                console.log('InValid');
                document.querySelector('.input-error-message').style.display = 'block';
                document.querySelector('.input-error-message').innerHTML = 'Please enter a valid Business Email!';
                // document.getElementById('new_button1').style.color = 'grey';
                document.getElementById('new_button1').style.opacity = '0.4';
                document.getElementById('new_button1').disabled = true;
                return true;

            }
            else{
                document.querySelector('.input-error-message').style.display = 'none';
                console.log('Valid');
                document.getElementById('new_button1').disabled = false;
                document.getElementById('new_button1').style.opacity = '1';
                return false;
            }
        }
        else if (email === '') {
            document.querySelector('.input-error-message').style.display = 'none';
            // document.getElementById('new_button1').style.color = 'grey';
            document.getElementById('new_button1').style.opacity = '0.4';
            document.getElementById('new_button1').disabled = true;
        }
        else {
            document.querySelector('.input-error-message').style.display = 'block';
            document.querySelector('.input-error-message').innerHTML = "Please enter a valid Email!";
            // document.getElementById('new_button1').style.color = 'grey';
            document.getElementById('new_button1').style.opacity = '0.4';
            document.getElementById('new_button1').disabled = true;
        }
    }

    isValidPhone(e) {
        console.log(e);
        if(e == '+' || e == '') {
            document.getElementById('new_button1').disabled = true;
            document.getElementById('new_button1').style.opacity = '0.4';
        }
        else {
            document.getElementById('new_button1').disabled = false;
            document.getElementById('new_button1').style.opacity = '1';
        }
    }
    componentDidMount(){
        $('body').on('focus','.input', function () {
            $(this).parent().addClass("focus");
        })

        $(function(e){
// =============================== AUTHOR : DEVAKS =============================== //
            window.main_question     = null;
            window.followup_question = null;
            window.followup_answer   = null;
            window.main_question_id  = null;


            $(".qstn01_data").hide();
            $(".qstn8_data").hide();

            $('body').on('change','input:radio', function (event) {

                console.log("targt",event.target)
                if ( event.target.id == "radio011"  ) {

                    localStorage.setItem("main_question",$("#radio011").val());
                    localStorage.setItem("main_question_id","radio011");
                    window.main_question    = $("#radio011").val();
                    window.main_question_id = "radio011";
                    $(".qstn6_data").hide();
                    $(".qstn3_data").show();
                    // $(".qstn6_data").hide('slide', {direction: 'left'},  300);
                    // setTimeout(function(){
                    //     $(".qstn3_data").show('slide', {direction: 'right'}, 350);
                    // },300)

                } else if ( event.target.id == "radio021" ) {

                    localStorage.setItem("main_question",$("#radio021").val());
                    localStorage.setItem("main_question_id","radio021");
                    window.main_question    = $("#radio021").val();
                    window.main_question_id = "radio021";
                    $(".qstn6_data").hide();
                    $(".qstn8_data").show();
                    // $(".qstn6_data").hide('slide', {direction: 'left'},  300);
                    // setTimeout(function(){
                    //     $(".qstn8_data").show('slide', {direction: 'right'}, 350);
                    // },300)

                } else if ( event.target.id == "radio031" ) {

                    localStorage.setItem("main_question",$("#radio031").val());
                    localStorage.setItem("main_question_id","radio031");
                    window.main_question    = $("#radio031").val();
                    window.main_question_id = "radio031";
                    $(".qstn6_data").hide();
                    $(".qstn01_data").show();

                    // $(".qstn6_data").hide('slide', {direction: 'left'},  300);
                    // setTimeout(function(){
                    //     $(".qstn01_data").show('slide',{direction:'right'},  350);
                    // },300)

                } else if ( event.target.id == "radio041" ) {

                    localStorage.setItem("main_question",$("#radio041").val());
                    localStorage.setItem("main_question_id","radio041");
                    window.main_question    = "I want to know more about the market."
                    window.main_question_id = "radio041";

                }
            });


            $('body').on('change','.followup_qustn_radio', function (event) {
                console.log("hey data","ddwd")
                if ( localStorage.getItem("radio041") == "radio02" ) {

                    localStorage.getItem("followup_question",$(this).parent().parent().parent().find("h5").text());
                    localStorage.getItem("followup_answer",$.trim( $("#custom_requirements").val() ));
                    window.followup_question  = $(this).parent().parent().parent().find("h5").text();
                    window.followup_answer    = $.trim( $("#custom_requirements").val() );

                } else if ( localStorage.getItem("radio041") != "radio04" ) {

                    localStorage.getItem("followup_question",$(this).parent().parent().parent().find("h5").text());
                    localStorage.getItem("followup_answer",$(this).val());
                    window.followup_question  = $(this).parent().parent().parent().find("h5").text();
                    window.followup_answer    = $(this).val();

                } else {

                    localStorage.getItem("followup_question",null);
                    localStorage.getItem("followup_answer",null);
                    window.followup_question  = null;
                    window.followup_answer    = null;

                }
            })

            $('body').on('click','.back-btn', function () {
                $(".qstn3_data").hide();
                $(".qstn8_data").hide();
                $(".qstn01_data").hide();
                $(".qstn6_data").show();
            })


// =============================== ENDS =============================== //



            $('.search-panel .dropdown-menu').find('a').click(function(e) {

                e.preventDefault();
                var param = $(this).attr("href").replace("#","");
                var concept = $(this).text();
                $('.search-panel span#search_concept').text(concept);
                $('.input-group #search_param').val(param);
                $('.input-group #search_parama').val(param);
            });
            $('.search-panelll .dropdown-menu').find('a').click(function(e) {

                e.preventDefault();
                var param = $(this).attr("href").replace("#","");
                var concept = $(this).text();
                $('.search-panelll span#search_concept1').text(concept);
                $('#search_param1').val(param);
            });
            $('.search-panell .dropdown-menu').find('a').click(function(e) {

               e.preventDefault();
                var param = $(this).attr("href").replace("#","");
                var concept = $(this).text();
                $('.search-panell span#search_concept').text(concept);
                $('.input-group #search_param').val(param);
            });
           /* show cart number */
            var cReports = JSON.parse(localStorage.getItem('cReports'));
            if (typeof cReports == 'undefined' || cReports == null)
            {
                cReports = [ ];
            }
            $('#cart_no').text(cReports.length);
            /* show cart number */
        });
    }


}
export default RequestSample;


// WEBPACK FOOTER //
// ./src/Forms/request-sample/request-sample.js